import React, { FC } from 'react';

import EventRegistration from 'buyside/components/presentation/EventPage/EventRegistration/eventRegistration';
import FadeInContainer from 'buyside/components/presentation/FadeInContainer/fadeInContainer';

import styles from './eventWhyAttendStyles.scss';

const EventWhyAttend: FC<{ isLoggedIn: boolean }> = ({ isLoggedIn }) => (
  <section id="why-attend" className={styles.whyContainer}>
    <div className={styles.whyContent}>
      <div className={styles.sectionEyebrow}>Why Attend</div>
      <hr className={styles.sectionDivider} />
      <FadeInContainer>
        <p className={styles.whyLead}>
          This dinner is designed for investors who value candid, high-signal conversation with
          peers. The goal is for every attendee to leave with sharper thinking, new relationships,
          and at least one idea or perspective they would not have encountered elsewhere.
        </p>
      </FadeInContainer>
    </div>
    <EventRegistration isLoggedIn={isLoggedIn} />
  </section>
);

export default EventWhyAttend;
